import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function MuiRadioGroup({ name, label, items, value, onChange, classname }) {
  const onSelect = (e) => {
    const selected = items.find((i) => i.value === e.target.value);
    onChange(name, selected);
  };

  return (
    <FormControl hidden={items.length === 0}>
      <FormLabel id="row-radio-buttons-group">{label}</FormLabel>
      <RadioGroup
        row
        aria-labelledby="row-radio-buttons-group"
        name={name}
        value={value ? value.value : null}
        onChange={onSelect}
      >
        {items.map((items) => {
          return (
            <FormControlLabel
              key={items.key}
              value={items.value}
              control={<Radio size="small" />}
              label={<span className={`radio-item ${classname ? classname : ''} ${value && items.value === value.value ? 'selected' : ''}`}>{items.key}</span>}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
